import { Component, OnInit, Input, Output, Inject, EventEmitter, DOCUMENT } from '@angular/core';


import { DialogUploadInspectionFileComponent, DialogUploadInspectionData } from '../dialog/dialog-upload-inspection-file.component';
import { MatDialog } from '@angular/material/dialog';

import { base64StringToBlob, blobToBase64String } from 'blob-util';

import {
  ApplicationApiService,
  AnnotationApiService,
  ApplicationInspectionFileApiService,
  BlobApiService,
} from '../../data-services/index';

import {
  IApplication, IApplicationInput,
  IApplicationInspectionFile, IApplicationInspectionFileInput,
  IAnnotationInput
} from '@ebb-v2/ebb-integration';

@Component({
    selector: 'ebb-portal-inspection-file-list',
    templateUrl: './inspection-file-list.component.html',
    styles: [],
    standalone: false
})
export class InspectionFileListComponent implements OnInit {
  @Input('title') title = 'Inspection Documents';
  @Input('application') application: IApplication;
  @Output() emitInspectionFileChangeEvent = new EventEmitter<boolean>();

  public inspectionFiles: IApplicationInspectionFile[] = [];
  public submittedInspection = false;
  public formProgressSave = false;

  constructor(
    private readonly dialogUpload: MatDialog,
    private readonly apiApplication: ApplicationApiService,
    private readonly apiAnnotation: AnnotationApiService,
    private readonly apiApplicationInspectionFileApi: ApplicationInspectionFileApiService,
    private readonly apiblob: BlobApiService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.apiApplicationInspectionFileApi.list(this.application.id).subscribe(
      data => {
        this.inspectionFiles = [...data];
        if (this.inspectionFiles && this.inspectionFiles.length > 0) {
          this.emitInspectionFileChangeEvent.emit(true);
        } else {
          this.emitInspectionFileChangeEvent.emit(false);
        }
      },
      err => console.warn(`ERROR: InspectionFiles ${JSON.stringify(err)}`)
    );
    this.submittedInspection =
      this.application.ebbInspectionStatus === 700000002 ? true : false;
  }

  public onUploadFileEvent(applicationInspectionFileId: string): void {
    const dialogUploadDataItem: DialogUploadInspectionData = {} as DialogUploadInspectionData;

    const dialogRef = this.dialogUpload.open(
      DialogUploadInspectionFileComponent,
      {
        width: '400px',
        data: dialogUploadDataItem
      }
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.uploadFileName.length > 0) {
        this.formProgressSave = true;
        const fileName = result.uploadFileName.replace(/[;,/?:@&=+$]/g, '');
        blobToBase64String(result.uploadFile)
          .then(base64string => {
            const fileString64 = base64string;
            const inspectionFile: IApplicationInspectionFileInput = {
              _Ebb_ApplicationId: this.application.id,
              name: fileName,
              // tslint:disable-next-line:radix
              fileType: parseInt(result.fileType),
              payLoad: '',
              submitDate: result.submitDate
            };

            const annotationInput: IAnnotationInput = {
              id: null,
              _Objectid_Value: '',
              objectTypeCode: 'cea_ebbapplicationinspectionfile',
              fileName: fileName,
              fileSize: result.uploadFile.size,
              mimeType: result.uploadFile.type,
              subject: fileName,
              noteText: '',
              documentBody: fileString64
            };

            this.apiApplicationInspectionFileApi
              .update(inspectionFile, applicationInspectionFileId)
              .subscribe(
                dataInspection => {
                  annotationInput._Objectid_Value = dataInspection.id;
                  this.apiAnnotation.saveAnnotation(annotationInput).subscribe(
                    dataAnnotation => {
                      inspectionFile.payLoad = dataAnnotation.id;
                      console.warn(`Annotation: ${inspectionFile.payLoad}`);
                      this.formProgressSave = false;
                      this.emitInspectionFileChangeEvent.emit(true);
                      this.ngOnInit();
                    },
                    err =>
                      console.warn(
                        `ERROR: Unable to update inspection file annotation`
                      )
                  );
                },
                err => console.warn(`ERROR: Unable to update inspection file`)
              );
          })
          .catch(err => {
            console.warn('Unable to convert file');
          });
      } else {
        console.warn(`ERROR: Unable to upload file without ID`);
      }
    });
  }

  public onViewFileEvent(itemId: string): void {
    const fileItem: IApplicationInspectionFile = this.inspectionFiles.filter(
      i => i.id === itemId
    )[0];

    if (!fileItem.payLoad && fileItem.payLoad.length === 0) {
      return;
    } else {
      this.saveAsSubmittedFile(fileItem);
    }
  }

  private saveAsSubmittedFile(fileItem: IApplicationInspectionFile): any {

    this.formProgressSave = true;
    if (fileItem.payLoad && fileItem.payLoad.length > 0) {
      this.apiblob
        .getTaskFiles(fileItem.payLoad, fileItem.name, 3)
        .subscribe(
          fileBlob => {
            this.formProgressSave = false;
            let navigator : any = window.navigator;
            if (navigator && navigator.msSaveOrOpenBlob) {
              navigator.msSaveOrOpenBlob(fileBlob, fileItem.name);
            } else {
              const downloadLink = this.document.createElement('a');
              downloadLink.href = window.URL.createObjectURL(fileBlob);
              downloadLink.download = fileItem.name;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              downloadLink.remove();
            }
          },
          error => {
            console.warn(error);
          }
        );
    }
  }
}
